import React, { ReactElement } from "react"
import StyledSelect from "./StyledSelect"
import { DataVisualizationGranularity } from "types/data-visualization.types"

interface GranularitySelectProps {
  value?: DataVisualizationGranularity
  onChange: (value: DataVisualizationGranularity) => void
  placeholder?: string
  label?: string
  required?: boolean
  width?: string
  height?: string
  disabled?: boolean
}

const granularityOptions = [
  {
    value: DataVisualizationGranularity.DAILY,
    text: "Daily",
  },
  {
    value: DataVisualizationGranularity.WEEKLY,
    text: "Weekly",
  },
  {
    value: DataVisualizationGranularity.MONTHLY,
    text: "Monthly",
  },
]

export default function GranularitySelect({
  value,
  onChange,
  placeholder = "Sélectionnez la granularité",
  label,
  required = false,
  disabled = false,
}: GranularitySelectProps): ReactElement {
  const handleChange = (selectedValue: string) => {
    if (
      selectedValue &&
      Object.values(DataVisualizationGranularity).includes(selectedValue as DataVisualizationGranularity)
    ) {
      onChange(selectedValue as DataVisualizationGranularity)
    }
  }

  return (
    <StyledSelect
      options={granularityOptions}
      value={value || ""}
      onChange={handleChange}
      placeholder={placeholder}
      label={label}
      required={required}
      width="80px"
      height="20px"
      disabled={disabled}
      fontSize={10}
    />
  )
}
